module.exports = "/assets/images/default_8330f6.png";